import React, { Component } from "react";
import SVGIcon from './SvgIcons';
import "./alert.css";
import * as Constants from "../Constants";
import * as Tagging from "../../tagging/LeadFormTagging";
class Alert extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mainBlueclass: props.notification,
            maxAttempt: props.maxAttempt
        }

    }

    dismiss() {
        this.props.showAlert(false);
    }

    componentDidMount(){
        this.ele && this.ele.focus();
        Tagging.leadsErrorEvent(this.props.leadType, this.state.maxAttempt ? Constants.ATTEMPT_MAX_TRIED_ERROR_MSG : Constants.ERROR_PAGE_MSG);
    }

    render() {
        return (
            <div className={"alert_notification"} tabIndex="-1" ref={(element)=>this.ele = element}>
                <div className="container_spring">
                    <div className="notification_container">

                        <SVGIcon name="icon-info-circle" className="alert_close_btn" />
                        <span className="middle_notification_stmt">
                            {this.state.maxAttempt ? Constants.ATTEMPT_MAX_TRIED_ERROR_MSG : Constants.ERROR_PAGE_MSG}
                        </span>
                        <div className="right_notification_close" onClick={() => this.dismiss()}>
                            <span className="desktop_notification_view">
                                DISMISS
                        </span>
                            <span className="hide_in_notification">
                                <SVGIcon name="icon-close" className="right_icon v2" onClick={() => this.dismiss()}/>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default (Alert);
